"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ponte": {
    "9cf69f41": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "skipSearch": false
    }],
    "campo-d-antuono": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "83f1ef14": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "skipSearch": false
    }],
    "campo-sportivo": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ee2d7679": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "skipSearch": false
    }],
    "canale": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "93ade494": [{
      "hkey": "b8cb3688",
      "slug": "ferrarisi",
      "name": "Ferrarisi",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-ferrarisi": [{
      "hkey": "b8cb3688",
      "slug": "ferrarisi",
      "name": "Ferrarisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3cc07b11": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "skipSearch": false
    }],
    "monte": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6cb636dc": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "skipSearch": false
    }],
    "piana-taverna-o-borgo": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "402c2cbf": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "skipSearch": false
    }],
    "puglia": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e3ce7f69": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "skipSearch": false
    }],
    "puglia-rioni-del-centro-urbano-ponte-alto": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "dfb6c3fd": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "skipSearch": false
    }],
    "staglio": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "77bc5d94": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "skipSearch": false
    }],
    "stazione": [{
      "hkey": "e1249ca2",
      "slug": "ponte",
      "name": "Ponte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;